var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "matchList" },
    [
      _c("Header"),
      _vm._v(" "),
      _c("div", { staticClass: "container" }, [
        _c("div", { staticClass: "match_ing" }, [
          _c("div", { staticClass: "match_ing_title" }, [
            _c(
              "span",
              { staticClass: "match_ing_title_title" },
              [
                _c("svg-icon", { attrs: { "icon-class": "robot" } }),
                _vm._v("\n                    征集中\n                "),
              ],
              1
            ),
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "match_ing_content" },
            [
              _vm._l(_vm.matchList, function (item, index) {
                return _c(
                  "div",
                  {
                    key: index,
                    staticClass: "match_card",
                    on: {
                      click: function ($event) {
                        return _vm.goDeatil(item.id)
                      },
                    },
                  },
                  [
                    _c("div", { staticClass: "coverBox" }, [
                      _c("img", { attrs: { src: item.cover, alt: "" } }),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "card_content" }, [
                      _c("span", [
                        _c("span", { staticClass: "match_card_type" }, [
                          _vm._v(_vm._s(item.type)),
                        ]),
                        _vm._v(
                          "\n                            - " +
                            _vm._s(item.name) +
                            "\n                        "
                        ),
                      ]),
                      _vm._v(" "),
                      _c("span", { staticClass: "endTime" }, [
                        _vm._v(
                          "\n                            结束时间：" +
                            _vm._s(item.matchEndTime) +
                            "\n                        "
                        ),
                      ]),
                    ]),
                  ]
                )
              }),
              _vm._v(" "),
              !_vm.matchList.length
                ? _c("span", { staticClass: "default" }, [
                    _c("img", {
                      attrs: {
                        src: require("@/assets/icon/notdata.png"),
                        alt: "",
                      },
                    }),
                    _vm._v(
                      "\n                    暂时没有赛事\n                "
                    ),
                  ])
                : _vm._e(),
            ],
            2
          ),
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "match_finish" },
          [
            _c(
              "div",
              { staticClass: "match_finish_title" },
              [
                _c("svg-icon", { attrs: { "icon-class": "end" } }),
                _vm._v("\n                已结束\n            "),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "worksTab" },
              [
                _vm._l(_vm.wroksTabList, function (item, index) {
                  return _c(
                    "span",
                    {
                      key: index,
                      class: _vm.worksTab == item ? "active" : "",
                      on: {
                        click: function ($event) {
                          return _vm.changeMatchTab(item)
                        },
                      },
                    },
                    [_vm._v(_vm._s(item == "" ? "全部" : item))]
                  )
                }),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "worksSearch" },
                  [
                    _c(
                      "el-input",
                      {
                        staticClass: "input-with-select",
                        attrs: { placeholder: "请输入内容" },
                        nativeOn: {
                          keyup: function ($event) {
                            if (
                              !$event.type.indexOf("key") &&
                              _vm._k(
                                $event.keyCode,
                                "enter",
                                13,
                                $event.key,
                                "Enter"
                              )
                            )
                              return null
                            return _vm.getmatchWorksList.apply(null, arguments)
                          },
                        },
                        model: {
                          value: _vm.searchContent,
                          callback: function ($$v) {
                            _vm.searchContent = $$v
                          },
                          expression: "searchContent",
                        },
                      },
                      [
                        _c("el-button", {
                          attrs: { slot: "append", icon: "el-icon-search" },
                          on: { click: _vm.getmatchWorksList },
                          slot: "append",
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              2
            ),
            _vm._v(" "),
            _vm._l(_vm.matchListEnd, function (item, index) {
              return _c("div", { key: index, staticClass: "matchDetail" }, [
                _c("img", {
                  staticClass: "matchCover",
                  attrs: { src: item.cover, alt: "" },
                  on: {
                    click: function ($event) {
                      return _vm.goDeatil(item.id)
                    },
                  },
                }),
                _vm._v(" "),
                _c("div", { staticClass: "matchDetail_content" }, [
                  _c("div", { staticClass: "matchDetail_title" }, [
                    _c("span", { staticClass: "match_name" }, [
                      _vm._v(_vm._s(item.name)),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "matchDetail_content_content" }, [
                      _c("span", { staticClass: "match_time" }, [
                        _vm._v(
                          _vm._s(
                            `${item.matchStartTime} 至 ${item.matchEndTime}`
                          )
                        ),
                      ]),
                      _vm._v(" "),
                      _c("span", { staticClass: "match_works_num_box" }, [
                        _c("span", { staticClass: "match_works_num" }, [
                          _vm._v("参赛作品"),
                        ]),
                        _vm._v(
                          "\n                                " +
                            _vm._s(item.worksList ? item.worksList.length : 0) +
                            "\n                            "
                        ),
                      ]),
                    ]),
                  ]),
                  _vm._v(" "),
                  item.worksList
                    ? _c(
                        "div",
                        { staticClass: "worksListBox" },
                        _vm._l(
                          item.worksList,
                          function (worksItem, worksIndex) {
                            return _c(
                              "div",
                              {
                                key: worksIndex,
                                staticClass: "match_works",
                                on: {
                                  click: function ($event) {
                                    return _vm.$router.push(
                                      `matchWorks/${worksItem.id}`
                                    )
                                  },
                                },
                              },
                              [
                                _c("img", {
                                  staticClass: "works_cover",
                                  attrs: {
                                    src: worksItem.cover
                                      ? worksItem.cover
                                      : worksItem.workPictureList[0],
                                    alt: "",
                                  },
                                }),
                                _vm._v(" "),
                                _c("div", { staticClass: "works_info" }, [
                                  _c("img", {
                                    staticClass: "user_avatar",
                                    attrs: {
                                      src: worksItem.authorAvatar,
                                      alt: "",
                                    },
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "span",
                                    { staticClass: "user_authorName" },
                                    [_vm._v(_vm._s(worksItem.authorName))]
                                  ),
                                  _vm._v(" "),
                                  _c("span", { staticClass: "works_name" }, [
                                    _vm._v(_vm._s(worksItem.name)),
                                  ]),
                                ]),
                              ]
                            )
                          }
                        ),
                        0
                      )
                    : _vm._e(),
                ]),
              ])
            }),
            _vm._v(" "),
            !_vm.matchListEnd.length
              ? _c("span", { staticClass: "default" }, [
                  _c("img", {
                    attrs: {
                      src: require("@/assets/icon/notdata.png"),
                      alt: "",
                    },
                  }),
                  _vm._v("\n                暂时没有相关数据\n            "),
                ])
              : _vm._e(),
          ],
          2
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--1!./node_modules/vue-loader/lib??vue-loader-options!./src/views/match/matchList.vue?vue&type=template&id=30794c8f&scoped=true&
// module id = null
// module chunks = 